if (!customElements.get("store-locations")) {
  customElements.define(
    "store-locations",
    class StoreLocations extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(
          this.querySelectorAll("[data-store-locations-item]")
        );
        this.mediaItems = Array.from(
          this.querySelectorAll("[data-store-locations-media]")
        );
        this.media = this.querySelector(".store-locations__media");

        if (this.items.length === 0) return;

        this._onActivate = (event) =>
          this.activate(this.items.indexOf(event.currentTarget));

        this._onLineTransitionEnd = (event) => {
          if (event.propertyName !== "clip-path") return;

          const item = event.currentTarget;
          if (item.classList.contains("is-active")) return;

          item.classList.remove("is-leaving");
        };

        this.items.forEach((item) => {
          item.addEventListener("mouseenter", this._onActivate);
          item.addEventListener("focusin", this._onActivate);
          item.addEventListener("click", this._onActivate);
          item.addEventListener("transitionend", this._onLineTransitionEnd);
        });

        const initialIndex = this.items.findIndex((item) =>
          item.classList.contains("is-active")
        );

        this.activate(initialIndex === -1 ? 0 : initialIndex);
      }

      disconnectedCallback() {
        this.items?.forEach((item) => {
          item.removeEventListener("mouseenter", this._onActivate);
          item.removeEventListener("focusin", this._onActivate);
          item.removeEventListener("click", this._onActivate);
          item.removeEventListener("transitionend", this._onLineTransitionEnd);
        });
      }

      activate(index) {
        if (index < 0 || index === this.activeIndex) return;

        this.items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;

          item.classList.toggle(
            "is-leaving",
            !isActive && itemIndex === this.activeIndex
          );
          item.classList.toggle("is-active", isActive);
        });

        this.mediaItems.forEach((media, mediaIndex) => {
          media.setAttribute(
            "aria-hidden",
            mediaIndex === index ? "false" : "true"
          );
        });

        this.media?.style.setProperty("--active-tab-index", index);

        this.activeIndex = index;
      }
    }
  );
}
